var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoInternet = function SvgNoInternet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#NoInternet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5 28c0-15.454-12.546-28-28-28S.5 12.546.5 28s12.546 28 28 28 28-12.546 28-28Z",
    style: {
      fill: "var(--secondary-bg-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 8c-9.278 0-16.8 8.148-16.8 18.2l.003.327C14.061 27.68 11 31.753 11 36.6c0 5.744 4.298 10.4 9.6 10.4H47c6.627 0 12-5.82 12-13 0-5.529-3.187-10.252-7.679-12.132C49.527 13.908 42.901 8 35 8Z",
    style: {
      fill: "var(--quaternary-bg-color)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.965 21.828-.051-.241a2.533 2.533 0 0 0-.227-.57C27.428 20.547 26.905 20 26 20s-1.428.547-1.687 1.017c-.118.213-.187.42-.227.57l-.062.301a1.9 1.9 0 0 0 .088.957c.112.305.323.618.686.846.322.201.723.309 1.202.309s.88-.108 1.202-.309c.363-.228.574-.541.686-.846a1.9 1.9 0 0 0 .11-.729l-.033-.288Zm0 0 .002.008-.003-.015.001.007ZM35.965 21.828l-.051-.241a2.533 2.533 0 0 0-.227-.57C35.428 20.547 34.905 20 34 20s-1.428.547-1.687 1.017c-.118.213-.187.42-.227.57l-.062.301a1.9 1.9 0 0 0 .088.957c.112.305.323.618.686.846.322.201.723.309 1.202.309s.88-.108 1.202-.309c.363-.228.574-.541.686-.846a1.9 1.9 0 0 0 .11-.729l-.033-.288Zm0 0 .002.008-.003-.015.001.007ZM30 31c-3.25 0-4 1-4 1h8s-.75-1-4-1Z",
    style: {
      fill: "var(--tertiary-color)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 32-.4-.3a.5.5 0 0 0 .4.8h8a.5.5 0 0 0 .4-.8l-.4.3c.4-.3.4-.3.399-.301l-.011-.015a1.169 1.169 0 0 0-.07-.077 1.71 1.71 0 0 0-.18-.159 3.239 3.239 0 0 0-.725-.409c-.669-.281-1.738-.539-3.413-.539-1.675 0-2.744.258-3.413.539a3.239 3.239 0 0 0-.725.409 1.614 1.614 0 0 0-.25.236l-.011.015C25.6 31.7 25.6 31.7 26 32Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "var(--tertiary-color)",
      strokeWidth: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "NoInternet_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 0.5,
    fill: "#fff",
    rx: 28
  }))));
};
export default SvgNoInternet;